// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider2_root__uAJ14","label":"Slider2_label__2R7Rw","labelSpacing":"Slider2_labelSpacing__tQfUY","tp":"Slider2_tp__2DYkP","main":"Slider2_main__1MzWL"};